"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get VIEW_KEY () {
        return VIEW_KEY;
    },
    get checkIsPersonalViewOwner () {
        return checkIsPersonalViewOwner;
    },
    get editorPersonalViewOnlyPermissions () {
        return editorPersonalViewOnlyPermissions;
    },
    get markPersonalViewIfNeeded () {
        return markPersonalViewIfNeeded;
    },
    get personalViewOwnerAllowedPermissions () {
        return personalViewOwnerAllowedPermissions;
    },
    get personalViewOwnerOnlyOps () {
        return personalViewOwnerOnlyOps;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const VIEW_KEY = Symbol.for('nc:view');
function markPersonalViewIfNeeded(req, view) {
    if (view && view.lock_type === _nocodbsdk.ViewLockType.Personal) {
        req[VIEW_KEY] = view;
    }
}
function checkIsPersonalViewOwner(req) {
    var _req_VIEW_KEY, _req_user;
    return ((_req_VIEW_KEY = req[VIEW_KEY]) == null ? void 0 : _req_VIEW_KEY.lock_type) === _nocodbsdk.ViewLockType.Personal && req[VIEW_KEY].owned_by === ((_req_user = req.user) == null ? void 0 : _req_user.id);
}
// Permissions that are view-specific operations checked separately
// by personalViewOwnerAllowedPermissions. Excluded from the non-owner
// write restriction check.
const PERSONAL_VIEW_MANAGEMENT_PERMISSIONS = [
    'viewColumnUpdate',
    'viewColumnCreate',
    'hideAllColumns',
    'showAllColumns',
    'gridColumnUpdate',
    'gridViewUpdate',
    'galleryViewUpdate',
    'kanbanViewUpdate',
    'mapViewUpdate',
    'calendarViewUpdate',
    'listViewUpdate',
    'viewRowColorConditionAdd',
    'viewRowColorConditionUpdate',
    'viewRowColorConditionDelete',
    'viewRowColorSelectAdd',
    'viewRowColorInfoDelete',
    'rowColorConditionsFilterCreate'
];
const personalViewOwnerOnlyOps = [
    'filterCreate',
    'filterUpdate',
    'filterDelete',
    'sortCreate',
    'sortUpdate',
    'sortDelete'
];
const editorPersonalViewOnlyPermissions = [
    'sortCreate',
    'sortUpdate',
    'sortDelete',
    'filterCreate',
    'filterUpdate',
    'filterDelete',
    ...PERSONAL_VIEW_MANAGEMENT_PERMISSIONS
];
const personalViewOwnerAllowedPermissions = [
    'filterList',
    'filterGet',
    'filterChildrenList',
    'filterCreate',
    'filterUpdate',
    'filterDelete',
    'sortList',
    'sortGet',
    'sortCreate',
    'sortUpdate',
    'sortDelete',
    'columnList',
    'viewUpdate',
    'viewColumnUpdate',
    'viewColumnCreate',
    'hideAllColumns',
    'showAllColumns',
    'gridColumnUpdate',
    'gridViewUpdate',
    'galleryViewUpdate',
    'kanbanViewUpdate',
    'mapViewUpdate',
    'calendarViewUpdate',
    'listViewUpdate',
    'viewRowColorConditionAdd',
    'viewRowColorConditionUpdate',
    'viewRowColorConditionDelete',
    'viewRowColorSelectAdd',
    'viewRowColorInfoDelete',
    'rowColorConditionsFilterCreate'
];
